export default __webpack_public_path__ + "static/media/cxp.94792706.png";